import {
  Home,
  User,
  Users,
  Calendar,
  Briefcase,
  Menu,
  X,
  Pencil,
  Clock,
  CircleCheck,
  AlertTriangle,
  ChevronRight,
  ChevronDown,
  ChevronLeft,
  ChevronUp,
  LogOut,
  Plus,
  Search,
  Mail,
  Phone,
  Building2,
  ShieldCheck,
  CreditCard,
  MapPin,
  IdCard,
  Sun,
  FileText,
  TrendingUp,
  TrendingDown,
  Award,
  Bell,
  RefreshCw,
  LayoutDashboard,
  Settings,
  CircleHelp,
  Download,
  IndianRupee,
  ClipboardList,
  BarChart3,
  CheckCircle2,
  XCircle,
  Eye,
  EyeOff,
  Upload,
  Loader2,
  Lock,
  Info,
  Trash2,
} from 'lucide-react';

function BonusIcon({ size = 20, color = 'currentColor', className = '', strokeWidth = 1.5 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`icon ${className}`}
      aria-hidden="true"
    >
      <path d="M3.5 10.5 12 7l8.5 3.5" />
      <path d="M5 10.5v7.25L12 20.5V13" />
      <path d="M19 10.5v7.25L12 20.5V13" />
      <path d="m9.2 8.2-1.7-1.5" />
      <path d="m14.8 8.2 1.7-1.5" />
      <path d="M12 3.5 13 5.7l2.4.2-1.8 1.5.6 2.3L12 8.4 9.8 9.7l.6-2.3-1.8-1.5 2.4-.2L12 3.5Z" />
      <path d="m16.9 4.8.5-.8" />
      <path d="m18.7 7.2.9.1" />
      <path d="m7.1 4.8-.5-.8" />
      <path d="m5.3 7.2-.9.1" />
    </svg>
  );
}

function getIconComponent(name) {
  switch (name) {
    case 'home': return Home;
    case 'user': return User;
    case 'users': return Users;
    case 'calendar': return Calendar;
    case 'briefcase': return Briefcase;
    case 'menu': return Menu;
    case 'close': return X;
    case 'edit': return Pencil;
    case 'clock': return Clock;
    case 'check': return CircleCheck;
    case 'alert': return AlertTriangle;
    case 'chevronRight': return ChevronRight;
    case 'chevronDown': return ChevronDown;
    case 'chevronLeft': return ChevronLeft;
    case 'chevronUp': return ChevronUp;
    case 'logout': return LogOut;
    case 'plus': return Plus;
    case 'search': return Search;
    case 'mail': return Mail;
    case 'phone': return Phone;
    case 'building': return Building2;
    case 'shield': return ShieldCheck;
    case 'creditCard': return CreditCard;
    case 'mapPin': return MapPin;
    case 'idCard': return IdCard;
    case 'sun': return Sun;
    case 'fileText': return FileText;
    case 'trendingUp': return TrendingUp;
    case 'trendingDown': return TrendingDown;
    case 'award': return Award;
    case 'bell': return Bell;
    case 'refresh': return RefreshCw;
    case 'dashboard': return LayoutDashboard;
    case 'settings': return Settings;
    case 'help': return CircleHelp;
    case 'download': return Download;
    case 'salary': return IndianRupee;
    case 'clipboardList': return ClipboardList;
    case 'barChart': return BarChart3;
    case 'checkCircle': return CheckCircle2;
    case 'xCircle': return XCircle;
    case 'eye': return Eye;
    case 'eyeOff': return EyeOff;
    case 'upload': return Upload;
    case 'loader': return Loader2;
    case 'lock': return Lock;
    case 'info': return Info;
    case 'trash': return Trash2;
    case 'bonus': return BonusIcon;
    default: return null;
  }
}

export default function Icon({ name, size = 20, color = 'currentColor', className = '', strokeWidth = 1.5 }) {
  const LucideIcon = getIconComponent(name);
  if (!LucideIcon) return null;

  return (
    <LucideIcon
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={`icon ${className}`}
      aria-hidden="true"
    />
  );
}
